import type { TrainingDetailInstructor } from '@/entities/Training';
import { TRAINING_EMPTY_VALUE } from './trainingEmptyValue';

export function buildInstructorNameLabel(
  instructor: Pick<TrainingDetailInstructor, 'name' | 'registrationNumber'>
): string {
  if (!instructor.name) return TRAINING_EMPTY_VALUE;
  return instructor.registrationNumber
    ? `${instructor.name} - ${instructor.registrationNumber}`
    : instructor.name;
}
